// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"44":"692438b5486247af","831":"7618fea63d3fd89d"}[chunkId] + ".js";
};